import type { IconData } from '@stacksjs/iconify-core'

export const toiletWomenFlat: IconData = {
  "body": "<path fill=\"#8fbffa\" d=\"M17.5 8.5a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0-13 0m6.5 8c-1.665 0-2.991.086-3.977.188c-1.52.158-2.78 1.102-3.468 2.429c-1.32 2.543-3.653 7.438-5.23 12.998c-.576 2.037.89 4.004 2.98 4.123c.717.041 1.541.083 2.463.12l.547 6.847c.128 1.596 1.332 2.925 2.958 3.09q.463.047.98.088a1.48 1.48 0 0 0 1.59-1.415l.364-7.99a.5.5 0 0 1 .5-.478h.588a.5.5 0 0 1 .5.477l.363 7.99a1.48 1.48 0 0 0 1.59 1.416q.517-.041.98-.088c1.626-.165 2.83-1.494 2.958-3.09l.548-6.847c.921-.037 1.745-.079 2.463-.12c2.09-.119 3.556-2.086 2.979-4.123c-1.576-5.56-3.91-10.455-5.23-12.998c-.688-1.327-1.948-2.271-3.467-2.429A39 39 0 0 0 24 16.5\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default toiletWomenFlat
